import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'
import { CacheUserAddress, AddressEditInfo } from '@/types/address'

export default function getCacheUserAddressInfo(): {
  userAddressInfo: ComputedRef<AddressEditInfo>
  setUserAddress: (addressObj?: CacheUserAddress) => void
  isDefault: ComputedRef<boolean>
} {
  const store = useStore()
  const guid: ComputedRef<string> = computed(() => {
    return store.getters.userGuid
  })
  const userAddressInfo: ComputedRef<AddressEditInfo> = computed((): AddressEditInfo => {
    const obj = store.state.userAddress.find((it: CacheUserAddress) => it.userGuid === guid.value)
    if (obj) {
      return obj.addressInfo || null
    }
    return null
  })

  const setUserAddress: (addressObj?: CacheUserAddress) => void = (addressObj: CacheUserAddress): void =>{
    store.commit('setUserAddress', addressObj)
  }
  const isDefault: ComputedRef<boolean> = computed((): boolean => {
    return userAddressInfo.value?.isDefault || false
  })
  return {
    userAddressInfo,
    setUserAddress,
    isDefault,
  }
}
